// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';

import style from './UploadBox.scss';
import icons from '../../../../../assets/styles/icons.scss';

type Props = {
  isLoading?: boolean;
  error?: boolean;
  hasInvoice: boolean;
  uploadedIntl: string;
  uploadIntl: string;
  handleRejectedFile: (files: File[]) => void;
  handleChangeFile: (files: File[]) => void;
};

export default class UploadBox extends Component<Props> {
  render() {
    const {
      isLoading, error, hasInvoice, uploadedIntl,
      uploadIntl, handleRejectedFile, handleChangeFile,
    } = this.props;
    return (
      <Dropzone accept="application/pdf,image/jpeg,image/jpg,image/png"
                multiple={false}
                maxSize={3145728}
                className={classNames(style.dropzone, { [style.error]: error })}
                activeClassName={style.active}
                disabledClassName={style.disabled}
                disabled={false}
                onDropAccepted={handleChangeFile}
                onDropRejected={handleRejectedFile}>
        {hasInvoice && !isLoading &&
        <section className={style.invoiceWrap}>
          <article className={style.leftWrap}>
            <i className={icons.iconListMedium}/>
            <FormattedMessage id={uploadedIntl}>{
              txt => <span className={style.text}>{txt}</span>
            }</FormattedMessage>
          </article>
          <i className={classNames(icons.iconRefreshMedium, style.right)}/>
        </section>}
        {!hasInvoice &&
        <section className={style.uploadInvoiceWrap}>
          <article className={style.leftIconWrap}>
            <i className={icons.iconPictureMedium}/>
          </article>
          <article className={style.middleWrap}>
            <i className={classNames(icons.iconUploadCloudMedium, style.upload)}/>
            <FormattedMessage id={uploadIntl}>{
              txt => <p className={style.buttonLabel}>{txt}</p>
            }</FormattedMessage>
          </article>
        </section>}
      </Dropzone>
    );
  }
}

UploadBox.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  handleRejectedFile: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  uploadedIntl: PropTypes.string.isRequired,
  uploadIntl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Sale/components/UploadBox/UploadBox.jsx